import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { onDegraded } from "@/lib/chatClient";

export function DegradedBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const off = onDegraded(() => setVisible(true));
    return off;
  }, []);

  if (!visible) return null;

  return (
    <div className="mx-auto mt-2 w-full max-w-3xl px-3 sm:px-5 animate-fade-up">
      <div
        role="status"
        className="flex items-center gap-2 rounded-md border border-warning bg-warning/10 px-4 py-2 text-sm text-warning-foreground"
      >
        <AlertTriangle className="h-4 w-4 shrink-0 text-warning" />
        <span className="flex-1">
          Modalità demo attiva — alcune risposte potrebbero essere generiche o non aggiornate.
        </span>
        <button
          onClick={() => setVisible(false)}
          className="rounded p-1 text-muted-foreground hover:bg-background/40"
          aria-label="Chiudi avviso"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}